<template>
  <div v-if="showEvents" class="inline-block">
    <div class="border-2 border-gray-200 rounded">
    <h5>Recent Report Events</h5>
      <div class="text-left">

        <ul role="list">
            <li v-for="item in feedItems" class="pb-2 px-2">
                <span class="text-sm text-gray-500">
                  {{ feedText(item.user.display_name, item.report_action_type, item.report_name, item.created_at)}}
                </span>
          </li>
        </ul>
        </div>

    </div>
    <div class="pt-2">
      <button-blue-secondary @click="navToHistory()" class="text-sm w-2/5">View All Events</button-blue-secondary>
      <button-blue-secondary @click="hideEvents()" class="text-sm w-2/5">Hide Events</button-blue-secondary>
    </div>

  </div>
  <div v-else>
    <button-blue-secondary @click="enableEvents()" class="text-sm w-2/5">Show Report History Events</button-blue-secondary>
  </div>

</template>

<script>

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";

export default {
  name: "ReportHistoryFeed",
  mixins: [SonicuCoreMixin, iconNamesMixin],
  components: {
    ButtonBlueSecondary,
  },

  props: {
    reportHistories: Array
  },
  data() {
    return {
      data: [],
      feedItems: [],
      showEvents: true
    }

  },
  created() {
    this.createFeedItems();
  },
  mounted() {
  },
  methods: {
    feedText(user, action, reportName, date){
      let actionText = {
        'review': 'reviewed',
        'approve': 'approved'
      }
      return `${user} ${actionText[action]} ${reportName} on ${date}`
    },
    createFeedItems(){
      let newFeedItems = [];

      this.reportHistories.forEach(function(reportHistory){
        reportHistory.reviews.forEach(function (review){
          review['report_name'] = reportHistory.report_template.report_name
          newFeedItems.push(review);
        });
      });

      newFeedItems.sort(function(a,b){
        return new Date(b.created_at) - new Date(a.created_at);
      });
      this.feedItems = newFeedItems.slice(0,5);

    },
    navToHistory(){
      window.location.href = this.company.buildCompanyRoute(`report-history/`)
    },
    hideEvents(){
      this.showEvents = false;
    },
    enableEvents(){
      this.showEvents = true;
    }
  },
  computed: {
  },
  watch: {
  },
}
</script>

<style scoped>

</style>